import { render, staticRenderFns } from "./ClaimedCouponModal.vue?vue&type=template&id=0f2e13d0&scoped=true&"
import script from "./ClaimedCouponModal.vue?vue&type=script&lang=js&"
export * from "./ClaimedCouponModal.vue?vue&type=script&lang=js&"
import style0 from "./ClaimedCouponModal.vue?vue&type=style&index=0&id=0f2e13d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2e13d0",
  null
  
)

export default component.exports